export const BrandsEndpoints = {
    list: () => '/brands/list',
    create: () => '/brands',
    update: (id: string) => `/brands/${id}`,
    delete: (id: string) => `/brands/${id}`,
};
